/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const matchain_chain_about = () => `Matchain is a decentralized AI blockchain platform dedicated to providing comprehensive digital identity solutions for all users. By integrating advanced artificial intelligence, Matchain enhances data categorization and user profiling, seamlessly merging social logins from both Web2 and Web3 into a unified digital identity.`
